import type { IconProps } from '@/components/ui/icon';
import {
  InstagramIcon,
  NewTwitterIcon,
  TiktokIcon,
  YoutubeIcon,
} from '@/components/ui/icon/brands';
import { Link01Icon } from '@/components/ui/icon/glyphs';

const ICONS: Record<string, IconProps['icon']> = {
  x: NewTwitterIcon,
  twitter: NewTwitterIcon,
  youtube: YoutubeIcon,
  tiktok: TiktokIcon,
  instagram: InstagramIcon,
};

const LABELS: Record<string, string> = {
  x: 'X',
  twitter: 'X',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  instagram: 'Instagram',
};

/** Brand glyph for a partner social platform key; generic link for unknown platforms. */
export function partnerSocialIcon(platform: string): IconProps['icon'] {
  return ICONS[platform.toLowerCase()] ?? Link01Icon;
}

/** Display label for a partner social platform key, falling back to the stored key. */
export function partnerSocialLabel(platform: string): string {
  return LABELS[platform.toLowerCase()] ?? platform;
}
